import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$webinarId/forgot-password')({});
